const mpaCoreViewPathBase = '/app-core'

export default {
  'email-template-dir': mpaCoreViewPathBase + '/email/user-templates/',
  'basic-email.template.html': mpaCoreViewPathBase + '/email/user-templates/basic-email.template.html'
}
